import { render, staticRenderFns } from "./bill-of-materials-material.vue?vue&type=template&id=10b5b964"
import script from "./bill-of-materials-material.vue?vue&type=script&lang=js"
export * from "./bill-of-materials-material.vue?vue&type=script&lang=js"
import style0 from "./bill-of-materials-material.vue?vue&type=style&index=0&id=10b5b964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports